<div class="row" style="margin-top:65px">
    <div class="col-12 col-md-9">
      <div class="row">
        <div class="col-12 col-md-5">
          <img src="assets/dashboard.png" class="img-fluid radius5 border" alt="Welara Horse" title="Welara Horse" />
        </div>
        <div class="col-12 col-md-7">
          <div class="row">
            <div class="col-12 col-md-4 mb-3">
              <div class="card pointer bg_bluelt" (click)="goRoute('hourglass')">
                <div class="card-body text-center">
                  <i class="fas fa-fw fa-lg fa-hourglass c_blue"></i>
                  <div class="card_label">Hourglass</div>
                </div>

              </div>
            </div>

            <div class="col-12 col-md-4 mb-3">
              <div class="card pointer bg_bluelt" (click)="goRoute('academy')">
                <div class="card-body text-center">
                  <i class="fas fa-fw fa-lg fa-graduation-cap c_blue"></i>
                  <div class="card_label">Welara Academy</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3 d-none">
              <div class="card pointer bg_bluelt" (click)="goRoute('dynamicsqlgrid/pp_table_info')">
                <div class="card-body text-center">
                  <i class="fas fa-fw fa-lg fa-edit c_blue"></i>
                  <div class="card_label">Dynamic SQL Grid</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <div class="card pointer" (click)="goRoute('/pfs')">
                <div class="card-body text-center bg_bluelt">
                  <i class="fas fa-fw fa-lg fa-money-check-alt c_blue"></i>
                  <div class="card_label">PFS</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <div class="card pointer">
                <div class="card-body text-center bg_bluelt">
                  <i class="fas fa-fw fa-lg fa-hard-drive c_blue"></i>
                  <div class="card_label">File Storage</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <div class="card bg_light">
                <div class="card-body text-center">
                  <i class="fas fa-fw fa-lg fa-clock c_greydk"></i>
                  <div class="card_label c_greydk">MinutesMaker</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <div class="card pointer d-none" (click)="goRoute('/billing-generator')">
                <div class="card-body text-center bg_bluelt">
                  <i class="fas fa-fw fa-lg fa-receipt c_blue"></i>
                  <div class="card_label">Bill Generator</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      
    </div>
    <div class="col-12 col-md-3">
        <div class="scroll_div radius5 border" id="dashCalendar">
            <app-calendar-slim [showAddButton]="false" [targetObject]="'dashCalendar'"></app-calendar-slim>
        </div>
    </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <app-btc-price-tracker></app-btc-price-tracker>
  </div>
</div>
